<template>
<div class='user-settings'>
  <div class="header">
    <div class="section profile">
      <div>
        <div class="profile-picture">
          <photo-upload
            :enableEdits="true"
            :photoDefault="defaultPhoto"
            buttonClass="button is-primary"
            :showMessages="false"
            @photo-submit="photo_upload"
            @photo-change="photo_changed"
            >
          </photo-upload>
        </div>

        <b-field label="Tu nombre"
            type="" message="">
            <b-input v-model="newUserInfo.name" maxlength="30"></b-input>
        </b-field>
        <b-field label="Web / Redes sociales"
            type="" message="Cuando publiques un proyecto, todo el mundo podrá ver esta dirección.">
            <b-input v-model="newUserInfo.social_link" maxlength="100"></b-input>
        </b-field>

        <b-field label="Tu descripción"
            type="" message="" >
            <b-input v-model="newUserInfo.description " maxlength="140" type="textarea" placeholder="¿Quieres contar algo más sobre ti?"></b-input>
        </b-field>
        <div class="field">
            <b-switch v-model="newUserInfo.acceptedReceivingEmails">
              Acepto recibir emails con información sobre el proyecto de ProgramaLaPlaza
            </b-switch>
        </div>

        <!-- save -->
        <div class = "save-area">
          <a class="btn btn-bg-colored" v-on:click="saveChanges">Guardar Cambios </a>
        </div>

        <!-- avanzado -->
        <div class = "advanced-area">
          <label class = "label">Avanzado</label>
          <div class="field">
          <b-switch v-model="showDangerOptions"> Mostrar opciones irreversibles </b-switch>
          </div>
          <b-collapse :open="showDangerOptions">
             <!-- <button class="button is-primary" slot="trigger" @click="showDangerOptions = !showDangerOptions"> {{ showDangerOptions? "Ocultar opciones irreversibles": "Mostrar opciones irreversibles"}} </button> -->
            <div class="notification">
              <div class="content">
                <p>Borrar tu cuenta para siempre</p>
                <a class="button is-danger" v-on:click="confirmCustomDelete" >BORRAR CUENTA</a>
              </div>
            </div>
         </b-collapse>
       </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import PhotoUpload from '../UI/PhotoUpload'
export default {
  name: 'UserSettings',
  components: {
    PhotoUpload
  },
  props: {},
  computed: {
    myUserInfo () {
      return this.$store.state.user.userInfo
    },
    myProjects () {
      return this.$store.getters['user/myProjectList']
    },
    defaultPhoto () {
      if (this.myUserInfo.picture) return this.myUserInfo.picture
      else return '/static/img/student.png'
    }
  },
  data: () => ({
    showAddClassroom: false,
    newUserInfo: {
      name: '',
      description: '',
      acceptedReceivingEmails: false
    },
    showDangerOptions: false
  }),
  methods: {
    getProperty: function (obj, property) {
      return this._.get(obj, property, '')
    },
    loadUserInfo: function () {
      this.$store.dispatch('user/fetchUserInfo')
        .then(() => {
          this.newUserInfo.name = this.$store.state.user.userInfo.name
          this.newUserInfo.social_link = this.$store.state.user.userInfo.social_link
          this.newUserInfo.description = this.$store.state.user.userInfo.description
          this.newUserInfo.acceptedReceivingEmails = this.$store.state.user.userInfo.usersettings.acceptedReceivingEmails
        })
      this.$store.dispatch('user/fetchMyProjects')
    },
    saveChanges: function () {
      this.$store.dispatch('user/setMyTerms', this.newUserInfo.acceptedReceivingEmails)
      this.$store.dispatch('user/saveChangesProfile', {'name': this.newUserInfo.name, 'description': this.newUserInfo.description, 'social_link': this.newUserInfo.social_link})
        .then((response) => {
          this.$toast.open('Perfil actualizado')
          this.$router.push({name: 'User'})
        })
        .catch((error) => {
          console.log(error)
          this.$toast.open('Error guardando cambios')
        })
    },
    confirmCustomDelete: function (event) {
      this.$dialog.confirm({
        title: 'Borrar Cuenta',
        message: '¿Estás seguro de que quieres <b>borrar</b> tu cuenta? Tus proyectos privados se borrarán. No puedes deshacer esta acción',
        confirmText: 'Borra Cuenta',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          let prom = this.$store.dispatch('user/deleteMyUser')
          prom.then(() => {
            this.$store.commit('user/clean')
            this.$store.commit('auth/LOGOUT')
            this.$store.commit('auth/REMOVE_TOKEN')
            this.$toast.open('Account deleted!')
            this.$router.replace('/logout')
          })
          prom.catch((error) => {
            this.$toast.open('Error borrando al usuario' + error)
          })
        }
      })
    },
    photo_upload: function (event, image) {
      this.$store.dispatch('user/uploadNewPhoto', image)
        .then(response => {
          this.$toast.open('Foto de perfil actualizada')
        }).catch((error) => {
          this.$toast.open('Error subiendo foto' + error)
        })
    },
    photo_changed: function () {

    }

  },
  created () {
    this.loadUserInfo()
  }
}
</script>

<style lang="less">
@import (reference) "../../assets/styles/main.less";
.user-settings{
  div.profile{
    margin:auto;
    max-width:600px;
    margin-top:60px;
  }

  .notification {
    margin-top: 2em;
  }
}

.save-area {
  display: flex;
  justify-content: flex-start;
  padding: 2em 0;
}

.advanced-area {
  border: 1px solid #e4e4e4;
  padding: 20px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/User/UserSettings.vue